import React from "react";

export default function GroupIcon() {
  return (
    <svg
      className="hover:text-darkblue"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
    >
      <path
        d="M7.83711 8.94922C10.1621 8.94922 12.0746 7.11172 12.0746 4.82422C12.0746 2.53672 10.1621 0.699219 7.83711 0.699219C5.51211 0.699219 3.59961 2.53672 3.59961 4.82422C3.59961 7.11172 5.51211 8.94922 7.83711 8.94922ZM7.83711 2.42422C9.22461 2.42422 10.3871 3.51172 10.3871 4.86172C10.3871 6.21172 9.26211 7.29922 7.83711 7.29922C6.41211 7.29922 5.28711 6.21172 5.28711 4.86172C5.28711 3.51172 6.44961 2.42422 7.83711 2.42422Z"
        fill="currentColor"
      />
      <path
        d="M17.2498 10.75C19.2748 10.75 20.8873 9.175 20.8873 7.1875C20.8873 5.2 19.2373 3.625 17.2498 3.625C15.2623 3.625 13.6123 5.2 13.6123 7.1875C13.6123 9.175 15.2623 10.75 17.2498 10.75ZM17.2498 5.35C18.3373 5.35 19.1998 6.175 19.1998 7.225C19.1998 8.275 18.3373 9.1 17.2498 9.1C16.1623 9.1 15.2998 8.275 15.2998 7.225C15.2998 6.175 16.1623 5.35 17.2498 5.35Z"
        fill="currentColor"
      />
      <path
        d="M17.4373 11.1234H17.0998C15.9748 11.1234 14.8873 11.4609 13.9498 12.0234C12.9373 10.6734 11.3248 9.77344 9.52481 9.77344H6.1873C3.1123 9.81094 0.674805 12.2484 0.674805 15.2859V17.9859C0.674805 18.6984 1.2373 19.2609 1.9498 19.2609H22.0873C22.7998 19.2609 23.3998 18.6609 23.3998 17.9484V17.0484C23.3623 13.7859 20.6998 11.1234 17.4373 11.1234ZM2.3623 17.5734V15.2859C2.3623 13.1859 4.0873 11.4609 6.1873 11.4609H9.52481C11.6248 11.4609 13.3498 13.1859 13.3498 15.2859V17.5734H2.3623ZM21.6748 17.5734H14.9998V15.2859C14.9998 14.6859 14.8873 14.0859 14.6998 13.5234C15.3748 13.0359 16.1998 12.8109 17.0623 12.8109H17.3998C19.7248 12.8109 21.6373 14.7234 21.6373 17.0484V17.5734H21.6748Z"
        fill="currentColor"
      />
    </svg>
  );
}
